<div class="context-fields-modal">
  <div class="modal-header">
    <h3>Configurar Barra de Contexto</h3>
    <p class="help-text">
      Selecione os campos do painel principal que devem aparecer como chips de contexto no topo de cada aba.
    </p>
  </div>

  <div class="modal-content">
    <!-- Ações rápidas -->
    <div class="quick-actions" *ngIf="fieldItems.length > 0">
      <button nz-button nzType="link" nzSize="small" (click)="selectAll()">
        Selecionar todos
      </button>
      <nz-divider nzType="vertical"></nz-divider>
      <button nz-button nzType="link" nzSize="small" (click)="deselectAll()">
        Limpar seleção
      </button>
      <span class="selection-count">
        {{ selectedCount }} de {{ fieldItems.length }} selecionado(s)
      </span>
    </div>

    <!-- Lista de campos com checkboxes -->
    <div class="fields-list" *ngIf="fieldItems.length > 0">
      <label *ngFor="let item of fieldItems; trackBy: trackByDataPath"
             nz-checkbox
             [(ngModel)]="item.checked"
             class="field-item">
        <span class="field-label">{{ item.field.label }}</span>
        <nz-tag *ngIf="item.field.sourceType === 'search' || item.field.sourceType === 'querySelect'"
                nzColor="blue" class="field-type-tag">pesquisa</nz-tag>
        <span class="field-path">{{ item.field.dataPath }}</span>
      </label>
    </div>

    <!-- Mensagem quando não há campos -->
    <nz-empty *ngIf="fieldItems.length === 0"
              [nzNotFoundContent]="'builderScreen.inspector.contextFields.empty' | translateTA">
    </nz-empty>
  </div>

  <div class="modal-footer">
    <button nz-button nzType="default" (click)="handleCancel()">
      Cancelar
    </button>
    <button nz-button nzType="primary" (click)="handleOk()">
      Salvar
    </button>
  </div>
</div>
